export const externalFetch = async (
    url: string,
    route: string,
    context: RequestInit = {},
    jwt: string | null = null,
) => {
    if (jwt) {
        if (Array.isArray(context.headers)) {
            context.headers = [
                ...context.headers.filter((entry) => entry[0] !== 'authorization'),
                ['authorization', `Bearer ${jwt}`],
            ];
        } else {
            context.headers = { ...context.headers, authorization: `Bearer ${jwt}` };
        }
    }
    return fetch(`${url}${route}`, context);
};
